var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"d-flex flex-wrap justify-center pa-1"},_vm._l((_vm.currencies),function(item){return _c('currency',{key:`currency-${ item }`,staticClass:"ma-1",attrs:{"name":`event_${ item }`}})}),1),_c('weather-chaos-fishing-history')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }